module.exports = __webpack_public_path__ + "img/esc_1_act_3.e9eb00ec.png";